<template>
	<div v-if="results.length">
		<table class="api-list">
			<thead>
				<tr>
					<th v-for="col in columns" :key="col.field" :class="{ collapse: col.collapse }">
						{{ col.label }}
					</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<APIListRow v-for="row of rows" :key="row._id" :data="row.data" :disabled="row.disabled">
					<slot :_id="row._id" />
				</APIListRow>
			</tbody>
		</table>
		<Pagination :pages="pages" />
	</div>
	<div v-else>
		<slot name="empty" />
	</div>
</template>

<script>
import APIListRow from '@/components/APIListRow'
import Pagination from '@/components/Pagination'
import state from '@/mixins/state'
import { mb } from '@/lib/helpers'

export default {
	name: 'APIList',
	props: {
		provider: {
			type: Object,
			required: true,
		},
		columns: {
			type: Array,
			required: true,
			validator: v => v.every(col => 'label' in col && 'field' in col),
		},
		disabledPredicate: Function,
	},
	data() {
		return {
			pages: 1,
			results: [],
		}
	},
	computed: {
		page() {
			return this.$route.query.page || 1
		},
		rows() {
			const accessors = this.columns.map(col => {
				return mb(col.field.split('.'))
			})
			return this.results.map(result => {
				// Create data to display in table
				const data = accessors.map((fn, i) => {
					const col = this.columns[i]
					return {
						field: col.field,
						value: fn(result),
						collapse: col.collapse,
					}
				})
				// Check if row should be disabled
				const disabled = this.disabledPredicate ? this.disabledPredicate(result) : false
				return {
					_id: result._id,
					data,
					disabled,
				}
			})
		},
	},
	methods: {
		async fetch() {
			this.setState('loading')
			try {
				// Build query
				const query = {}
				if (this.page > 1) {
					query.page = this.page
				}

				// Fetch results
				const { pages, results } = await this.provider.list(query)
				this.pages = pages
				this.results = results

				// Done
				this.setState('idle')
			} catch (err) {
				this.setState('error')
			}
		},
	},
	watch: {
		page(next, prev) {
			if (next !== prev) {
				this.fetch()
			}
		},
	},
	created() {
		this.fetch()
	},
	mixins: [state()],
	components: {
		APIListRow,
		Pagination,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';

.api-list {
	@extend %table;
}
</style>
